// Keep track of all loaded plugins. Useful for loading a plugin independent of
// the menu system. 
// the menu system.
export const loadedPlugins = {};
export const alwaysEnabledPlugins = [];
export let allMenuData = [];
/**
 * Set the menu data.
 *
 * @param  {IMenuEntry[]} menuData  The menu data.
 */
export function setAllMenuData(menuData) {
    allMenuData = menuData;
}
/**
 * Register a plugin as loaded.
 *
 * @param  {PluginParentClass} plugin  The plugin to register.
 */
export function registerLoadedPlugin(plugin) {
    // Throw an error if the plugin already registered.
    if (loadedPlugins[plugin.pluginId]) {
        throw new Error(`Plugin with id ${plugin.pluginId} already registered.`);
    }
    loadedPlugins[plugin.pluginId] = plugin;
    if (plugin.alwaysEnabled) {
        alwaysEnabledPlugins.push(plugin.pluginId);
    }
}
